// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"02fcdc47","129":"59db5861"}[chunkId] + ".chunk.css";
};